var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62158 18.2998V7.86543L5.24658 11.2404L4.03721 10.0311L9.46533 4.60293L14.8935 10.0311L13.6841 11.2404L10.3091 7.86543V18.2998H8.62158ZM0.465332 6.00918V1.9873C0.465332 1.5373 0.634082 1.14355 0.971582 0.806055C1.30908 0.468555 1.70283 0.299805 2.15283 0.299805H16.7778C17.2278 0.299805 17.6216 0.468555 17.9591 0.806055C18.2966 1.14355 18.4653 1.5373 18.4653 1.9873V6.00918H16.7778V1.9873H2.15283V6.00918H0.465332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExport);
export default __webpack_public_path__ + "static/media/icon-export.97877f6dfb0a85d0490151133a848c9d.svg";
export { ForwardRef as ReactComponent };